import { useStrictLocalization } from "@faire/web/common/localization";
import * as React from "react";
import styled from "styled-components";

import { Breadcrumb } from "@faire/retailer/components/Breadcrumb";
import { brandPage } from "@faire/retailer/paths";

interface IProps {
  brandName: string | undefined;
  brandToken: string;
  videoName: string | undefined;
  className?: string;
}

export const VideoBreadcrumbs: React.FC<IProps> = ({
  brandName: _brandName,
  brandToken,
  videoName: _videoName,
  className,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const brandName =
    _brandName ?? strictLocalize({ defaultMessage: "Brand Page" });
  const videoName =
    _videoName ?? strictLocalize({ defaultMessage: "Video Name" });
  return (
    <Wrapper className={className}>
      <Breadcrumb
        options={[
          {
            label: brandName,
            path: brandPage(brandToken),
          },
          {
            label: videoName,
          },
        ]}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 18px -24px;
`;
